import { render } from "./PasswordRule.vue?vue&type=template&id=60230e82&scoped=true"
import script from "./PasswordRule.vue?vue&type=script&lang=js"
export * from "./PasswordRule.vue?vue&type=script&lang=js"

import "./PasswordRule.vue?vue&type=style&index=0&id=60230e82&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-60230e82"

export default script